import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import Tags from './tags.jsx';
import UserText from '../../user_text.jsx';

class ReadOnly extends React.Component {
    static propTypes = {
        close: PropTypes.func.isRequired,
        markup: PropTypes.any.isRequired,
        children: PropTypes.node,
    };

    close = () => {
        this.props.close();
    };

    renderHeader = () => {
        const markup = this.props.markup;

        let headerText = markup.author_name + "'s ";
        if (markup.note_text) {
            headerText += 'Note';
        } else {
            headerText += 'Highlight';
        }

        const created = moment(markup.created);

        return (
            <header>
                <button onClick={this.close} className="close">
                    ×
                </button>
                {headerText}
                <time className="metadata" dateTime={created.toISOString()}>
                    {created.fromNow()}
                </time>
            </header>
        );
    };

    render() {
        const { markup } = this.props;

        const questionMarker = markup.isQuestion ? (
            <span className="is-question">
                <i className="cl-icon cl-icon-question-circle" />
                Question
            </span>
        ) : (
            false
        );

        return (
            <div>
                {this.renderHeader()}

                <div
                    data-container="note"
                    className="clearfix note-content is-uneditable"
                >
                    {questionMarker}

                    <UserText element="span">{markup.note_text}</UserText>

                    <Tags tags={this.props.markup.tags} />
                </div>
            </div>
        );
    }
}

export default ReadOnly;



// WEBPACK FOOTER //
// ./src/components/text_viewer/highlight/readonly.jsx